import { AppBar, Box } from '@mui/material'
import React from 'react'
import logo from '../assets/icons/logo.svg'
import styles from '../pages/healthNews/news.module.css'
import qrcode from '../assets/images/qrcode.png'

function Footer() {
    return (
        <AppBar
            // position="sticky"
            sx={{
                top: 'auto',
                bottom: 0,
                backgroundColor: '#FFFFFF',
                padding: '10px',
                color: '#000000',
                fontSize: '14px',
                "@media (max-width: 800px)": {
                    fontSize: '10px',
                    position: 'sticky'
                },
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                "@media (max-width: 500px)": {
                    display: 'grid',
                },
            }}>
                <Box sx={{
                    display: 'flex',
                    gridGap: '10px'
                }}>
                    <img className={styles.logo} src={logo} />
                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                        <Box sx={{
                            fontWeight: 600
                        }}>
                            <Box>สำนักงานแพทย์ สำนักงานสนับสนุน สำนักงานปลัดกระทรวงกลาโหม</Box>
                            <Box>Office for Medical Service of The Permanent Secretary for Defence (MED)</Box>
                        </Box>

                        <Box>
                            <Box>รายงานปัญหาการใช้งาน</Box>
                            <Box>Line official :
                                <span
                                    style={{ color: '#33A853', cursor: 'pointer', textDecoration: 'underline' }}
                                    onClick={() => { window.open('https://lin.ee/ojY08TD') }}
                                > healthsystem.mod</span>
                            </Box>
                        </Box>

                    </Box>
                </Box>

                <Box sx={{display: 'flex',alignItems: 'center'}}>
                    <img src={qrcode} className={styles.qrcode} />
                </Box>

            </Box>
        </AppBar>
    )
}

export default Footer
